{
	"common": {
		"actions": "Åtgärder",
		"add": "Lägg till",
		"close": "Stäng",
		"backToPlanvera": "Tillbaka till PlanVera",
		"cancel": "Avbryt",
		"description": "Beskrivning",
		"export": "Exportera",
		"filter": "Filtrera {{column}}",
		"import": "Importera",
		"name": "Namn",
		"open": "Öppna",
		"quantity": "Antal",
		"returnToPlanvera": "Återgå till PlanVera",
		"save": "Spara",
		"scale": "Skala",
		"signOut": "Logga ut",
		"unit": "Enhet"
	},
	"units": {
		"C62": "st",
		"XPK": "pkt"
	},
	"sidebar": {
		"collapse": "Fäll ihop meny",
		"expand": "Expandera meny",
		"files": "Filer",
		"language": "Språk",
		"openNavigation": "Öppna navigering",
		"products": "Produkter",
		"quantityList": "Mängdförteckning",
		"takeoffs": "Mängdavtagningar",
		"trash": "Papperskorg",
		"workPackages": "Arbetspaket"
	},
	"takeoffList": {
		"confirmDelete": "Flytta mängdavtagningen \"{{name}}\" till papperskorgen?",
		"confirmPermanentDelete": "Ta bort \"{{name}}\" permanent? Alla mätningar och data förstörs. Detta kan inte ångras.",
		"create": "Skapa mängdavtagning",
		"delete": "Ta bort",
		"deletedOn": "Borttagen {{date}}",
		"permanentDelete": "Ta bort permanent",
		"restore": "Återställ",
		"trash": "Papperskorg",
		"trashEmpty": "Papperskorgen är tom.",
		"descriptionLabel": "Beskrivning",
		"descriptionPlaceholder": "Beskrivning (valfritt)",
		"disciplineLabel": "Disciplin",
		"discipline": {
			"electrical": "el",
			"other": "övrigt",
			"plumbing": "VVS"
		},
		"duplicating": "Duplicerar…",
		"emptyCta": "Skapa mängdavtagning",
		"emptyDescription": "Skapa din första mängdavtagning för att börja räkna mängder.",
		"emptyTitle": "Inga mängdavtagningar ännu",
		"fileCount": "{{count}} filer",
		"locked": "Låst · {{count}} otillgängliga filer",
		"title": "Mängdavtagningar"
	},
	"frontpage": {
		"addFile": "Lägg till fil",
		"confirmDetachBody": "Detta tar permanent bort alla poster, mål och mätdata för {{name}} från denna mängdavtagning. Detta kan inte ångras.",
		"deleteData": "Ta bort data",
		"detachAndDelete": "Koppla från och ta bort data",
		"editDescription": "Redigera beskrivning",
		"editScale": "Redigera skala",
		"files": "Filer",
		"groupAttached": "Bifogade",
		"groupDetached": "Frånkopplade — data behållen",
		"groupTrashed": "I papperskorgen",
		"lockedNotice": "Denna mängdavtagning är tillfälligt låst medan fildata rensas eller åtkomsten synkroniseras om. Den försöker igen automatiskt — ladda om sidan om en minut.",
		"noFiles": "Inga filer i denna mängdavtagning ännu. Lägg till ritningar eller IFC-modeller för att börja mäta.",
		"quantityList": "Mängdförteckning",
		"quantityTakeoff": "Mängdavtagning",
		"reattach": "Återanslut",
		"removeRetainedData": "Ta bort behållen data",
		"workPackages": "Arbetspaket"
	},
	"flow": {
		"archivedReadOnly": "Arkiverat projekt — skrivskyddat",
		"collapseExport": "Fäll ihop rader vid export",
		"exportDialogTitle": "Exportera mängdförteckning",
		"exportFilenameLabel": "Filnamn",
		"locked": "Mängdavtagning låst",
		"lockedDescription": "Åtkomst väntar på synkronisering av behörigheter eller en behållen fil är otillgänglig."
	},
	"quantityTable": {
		"code": "Paket-ID / elnummer",
		"collapseAll": "Fäll ihop alla rader",
		"deleteRow": "Ta bort rad",
		"expandAll": "Expandera alla rader",
		"editRow": "Redigera rad",
		"empty": "Inget mätt och kopplat till mål ännu.",
		"mainProduct": "Huvudprodukt",
		"measurements": "Mätningar",
		"measurementLabel": "Mätning {{index}}",
		"segmentLabel": "Segment {{index}}",
		"contents": "Innehåll",
		"type": "Typ",
		"typeTask": "Uppgift",
		"typeProduct": "Produkt",
		"products": "Produkter",
		"showDetails": "Visa paketdetaljer",
		"showInViewer": "Visa i visaren",
		"system": "System",
		"tasks": "Uppgifter",
		"classifySelection": "Klassificera ({{count}})",
		"selectAll": "Markera alla rader",
		"classification": "Klassificering",
		"classificationFilter": "Filtrera efter klassificering"
	},
	"browser": {
		"allPackages": "Alla paket",
		"basicInfo": "Paketdetaljer",
		"code": "Kod",
		"date": "Datum",
		"emptyGroup": "Inga paket i denna grupp.",
		"groupTree": "Paketgrupper",
		"groups": "Grupper",
		"installationInfo": "Installationsdetaljer",
		"modified": "Ändrad",
		"name1": "Namn 1",
		"name2": "Namn 2",
		"noChildPackages": "Inga länkade paket",
		"ownPackages": "Egna paket",
		"ungrouped": "Ogrupperade",
		"editMode": "Redigera",
		"addPackage": "Lägg till paket",
		"editGroups": "Redigera grupper",
		"addGroup": "Lägg till grupp",
		"addSubgroup": "Lägg till undergrupp",
		"editGroup": "Redigera grupp",
		"deleteGroup": "Ta bort grupp",
		"confirmDeleteGroup": "Ta bort denna tomma grupp permanent?",
		"groupCode": "Gruppkod (valfritt)",
		"parentGroup": "Överordnad grupp",
		"confirmMoveTitle": "Flytta paket",
		"confirmMovePackage": "Flytta {{package}} till {{group}}?",
		"movePackage": "Flytta",
		"packageUnit": "Paketenhet",
		"quantity": "Antal",
		"sahkonro": "Elnr.",
		"searchPlaceholder": "Sök efter namn, kod eller produktnummer…",
		"sectionMainProducts": "Huvudprodukter ({{count}})",
		"sectionPackages": "Paket ({{count}})",
		"sectionProducts": "Produkter ({{count}})",
		"sectionWorks": "Arbeten ({{count}})",
		"toggleGroup": "Expandera eller fäll ihop grupp",
		"tyonro": "Arbetsnr.",
		"variantCount": "Installationsmetoder",
		"createDialogIntro": "Ett paket är en lista över uppgifts- och produktrader som förbrukas per en basenhet.",
		"createPackage": "Skapa paket",
		"createTitle": "Skapa arbetspaket",
		"addProductRow": "Lägg till produktrad",
		"addTaskRow": "Lägg till uppgiftsrad",
		"basisUnit": "Basenhet",
		"group": "Grupp",
		"importResult": "Importerade {{packages}} paket, {{versions}} nya versioner.",
		"importResultPlaceholders": "{{count}} platshållarprodukter skapade (synkronisering med Sähkönumerot fyller i riktiga namn senare).",
		"installation": "Installation",
		"newPackage": "Nytt paket",
		"noPackages": "Inga paket i katalogen ännu.",
		"noRows": "Inga rader ännu.",
		"packageCode": "Paket-ID",
		"packageCodeOptional": "Valfritt",
		"packageName": "Paketnamn",
		"product": "Produkt",
		"removeRow": "Ta bort rad",
		"rowUnit": "Radenhet",
		"rowsPerBasisUnit": "Rader (per basenhet)",
		"duplicatePackage": "Duplicera",
		"editPackage": "Redigera",
		"editTitle": "Redigera arbetspaket",
		"selectSubPackage": "Välj ett paket",
		"subPackage": "Delpaket",
		"restorePackage": "Återställ",
		"retirePackage": "Ta ur bruk",
		"searchPackages": "Sök paket",
		"searchProducts": "Sök produkter",
		"selectProduct": "Välj en produkt",
		"createProduct": "Skapa produkt",
		"loadMore": "Ladda fler",
		"newProduct": "Ny produkt",
		"noProducts": "Inga produkter hittades.",
		"productCode": "Produkt-ID",
		"productName": "Produktnamn",
		"productsTitle": "Produkter",
		"showRetired": "Visa ur bruk",
		"source": "Källa",
		"sourceOwn": "Egen",
		"sourceSahkonumerot": "Sähkönumerot",
		"sourceStul": "STUL",
		"subPackages": "Delpaket",
		"taskName": "Uppgiftsnamn",
		"title": "Arbetspaket",
		"favoritesGroup": "Favoriter",
		"favorite": "Favorit"
	},
	"picker": {
		"addFiles_one": "Lägg till {{count}} fil",
		"addFiles_other": "Lägg till {{count}} filer",
		"alreadyAttached": "Redan bifogad",
		"emptyFolder": "Denna mapp är tom.",
		"folderPath": "Mappsökväg",
		"title": "Lägg till filer i mängdavtagning"
	},
	"workspace": {
		"loading": "Laddar mängdavtagning…",
		"unavailable": "Mängdavtagning otillgänglig",
		"unavailableDescription": "Mängdavtagningen kunde inte laddas."
	},
	"viewer": {
		"unsavedEditsRejected": "Ändringar som gjordes offline sparades inte, eftersom projektet nu är skrivskyddat (det kan ha arkiverats).",
		"tools": {
			"navigate": "Navigera",
			"point": "Punktmätning",
			"route": "Sträckmätning",
			"area": "Areamätning",
			"measure": "Mät",
			"navigateShort": "Navigera",
			"pointShort": "Punkt",
			"routeShort": "Sträcka",
			"areaShort": "Area",
			"measureShort": "Mät"
		},
		"seedMethods": {
			"select": "Markera",
			"draw": "Rita"
		},
		"pointModes": {
			"select": "Markera",
			"add": "Lägg till punkter"
		},
		"granularity": {
			"group": "Gruppmarkering",
			"single": "Markering av enskilt objekt"
		},
		"panel": {
			"expand": "Öppna panel",
			"collapse": "Fäll ihop panel",
			"selectionLayers": "Markeringslager",
			"showAllSelectionLayers": "Visa alla markeringslager",
			"hideAllSelectionLayers": "Dölj alla markeringslager",
			"isolateSelectionLayers": "Visa endast markeringslager",
			"restoreLayers": "Återställ lager",
			"showLayer": "Visa lager",
			"hideLayer": "Dölj lager",
			"showOnlyLayer": "Visa endast detta lager"
		},
		"layers": "Lager",
		"nav": {
			"previousPage": "Föregående sida",
			"nextPage": "Nästa sida",
			"zoomIn": "Zooma in",
			"zoomOut": "Zooma ut",
			"resetView": "Återställ vy",
			"exit": "Avsluta"
		},
		"missingScaleWarning": "Ritningens skala är inte konfigurerad. Konfigurera skalan för att använda mätningar.",
		"clearSelection": "Rensa markering",
		"clearSelectionHint": "Rensa markering (Esc)",
		"scaleDialog": {
			"title": "Ange ritningsskala",
			"description": "Ange en skala för denna ritning för att börja mäta.",
			"editTitle": "Ändra ritningsskala",
			"editDescription": "Välj rätt skala för den här ritningen.",
			"saveChanges": "Spara",
			"recalculateWarning": "Mätningar räknas om med den nya skalan. Befintliga poster i mängdberäkningen behåller skalan de skapades med.",
			"close": "Stäng skaldialog",
			"scaleLabel": "Skala",
			"scalePlaceholder": "Välj skala",
			"customScaleLabel": "Anpassad skala",
			"customScalePlaceholder": "1:100",
			"customScaleHint": "Använd ett förhållande som 1:100.",
			"scaleUnitLabel": "Skalenhet",
			"scaleUnitPlaceholder": "Välj enhet",
			"save": "Spara och mät",
			"saving": "Sparar…",
			"saved": "Ritningsskala sparad",
			"saveError": "Det gick inte att spara ritningsskalan",
			"missingScale": "Välj en skala",
			"missingUnit": "Välj en enhet",
			"invalidScale": "Skalan måste använda ett positivt förhållande som 1:100"
		},
		"measure": {
			"title": "Mätningar",
			"selected": "{{count}} valda",
			"selectAll": "Markera alla",
			"clearSelection": "Rensa markering",
			"clearAll": "Rensa alla",
			"scale": "Skala: {{scale}} ({{unit}})",
			"scaleMissing": "Skala inte konfigurerad",
			"editScale": "Ändra skala",
			"display": "Visning",
			"totalArea": "Total area {{value}}",
			"totalLength": "Total längd {{value}}",
			"empty": "Inga mätningar ännu. Rita på ytan för att lägga till mätningar.",
			"locate": "Hitta mätning",
			"delete": "Ta bort mätning",
			"select": "Markera {{value}}",
			"deselect": "Avmarkera {{value}}",
			"color": "Mätningsfärg",
			"newColor": "Färg för nya mätningar",
			"selectionColor": "Markeringsfärg",
			"auto": "Auto",
			"autoColor": "Automatisk färg",
			"customColor": "Anpassad",
			"hue": "Nyans",
			"hex": "Hex-färg",
			"back": "Tillbaka",
			"tools": {
				"distance": "Avstånd",
				"path": "Sträcka",
				"area": "Area",
				"snap": "Fäst",
				"angle": "Vinkel",
				"clear": "Rensa"
			}
		},
		"picker": {
			"title": "Arbetspaket",
			"searchPlaceholder": "Sök efter namn, kod eller elnummer",
			"root": "Alla grupper",
			"loadMore": "Visa fler",
			"empty": "Inga paket hittades",
			"tabBrowse": "Bläddra",
			"tabRecents": "Senaste",
			"noRecents": "Inga nyligen använda paket ännu",
			"ownGroup": "Egna paket",
			"ungroupedGroup": "Ogrupperade",
			"incompatibleReason": "Inkompatibel enhet",
			"tabFavorites": "Favoriter",
			"noFavorites": "Inga favoritpaket ännu — stjärnmärk ett paket för att fästa det här",
			"variantCount": "{{count}} metoder",
			"variantCount_one": "{{count}} metod",
			"favorite": "Favorit"
		},
		"colorMode": {
			"title": "Färgläggning",
			"package": "Efter paket",
			"category": "Efter kategori",
			"classification": "Efter klassificering",
			"system": "Efter system",
			"custom": "Anpassade färger"
		},
		"area": {
			"added": "Area tillagd",
			"drawHint": "Tryck på ritningen för att rita en area; tryck på första hörnet för att stänga",
			"quantityLabel": "Antal",
			"rawLabel": "Uppmätt area",
			"perimeterLabel": "Omkrets",
			"labelLabel": "Etikett",
			"finish": "Slutför area",
			"createMeasurement": "Skapa mätning",
			"createHint": "Kontur stängd — tryck på Skapa mätning för att spara arean",
			"sectionTitle": "Areamätning"
		},
		"point": {
			"selectHint": "Markera en eller flera symboler på ritningen",
			"addHint": "Tryck på ritningen för att placera en punkt",
			"added": "Punkt tillagd",
			"addMeasurement": "Lägg till mätning"
		},
		"measurement": {
			"added": "Mätning tillagd",
			"addedCount_one": "{{count}} mätning tillagd",
			"addedCount_other": "{{count}} mätningar tillagda",
			"noLineGeometry": "Markeringen har ingen linjegeometri att dra sträcka på"
		},
		"wireRun": {
			"noExtension": "Ingen ytterligare dragning att utöka till.",
			"atMinimum": "Kabeldragningen är på sitt minimum.",
			"noConnectedSegments": "Inga anslutna kabelsegment hittades.",
			"stillLoading": "Ritningen laddas fortfarande — försök igen om en stund."
		},
		"autoTune": {
			"tuned": "Markeringsgruppering justerad: {{granularity}} (poäng {{score}})",
			"nothingToGroup": "Automatisk justering hittade inget att gruppera på denna sida.",
			"failed": "Automatisk justering misslyckades."
		},
		"entry": {
			"untargetedWarning": "Inget arbetspaket tilldelat — räknas inte in i kalkylen",
			"position": "Position",
			"factor": "Faktor",
			"package": "Arbetspaket",
			"noPackage": "Inget paket",
			"packageSelected": "Paket valt",
			"color": "Anpassad färg",
			"noSystemMatches": "Inga system hittades",
			"delete": "Ta bort mätning",
			"incompatiblePackage": "Detta pakets enhet är inte kompatibel med mätningen"
		},
		"search": {
			"presets": {
				"strict": "Strikt",
				"normal": "Normal",
				"loose": "Lös"
			},
			"advanced": "Avancerat",
			"minScore": "Matchningströskel",
			"sizeTolerance": "Storlekstolerans",
			"run": "Hitta liknande",
			"matchCount": "{{included}} av {{count}} träffar inkluderade",
			"matchRow": "Träff {{index}} · {{score}} %",
			"assignAll": "Lägg till {{count}} mätningar",
			"clear": "Rensa resultat",
			"title": "Symbolsökning"
		},
		"route": {
			"drafting": {
				"draw": "{{count}} punkter placerade — dubbelklicka eller Slutför för att avsluta"
			},
			"pickCable": "Välj kabel…",
			"removeSegment": "Ta bort segment",
			"gapSegment": "Lucka",
			"gapSegmentHint": "Inte kabel: förenar två separata delar av denna mätning. Räknas inte in i längden.",
			"reconnectSegment": "Återanslut",
			"changeCable": "Byt kabel…",
			"finish": "Slutför sträcka",
			"segment": "Segment {{index}}",
			"segments": "Segment",
			"deltaH": "Δh",
			"deltaHTooltip": "Vertikalt avstånd / installationstillägg",
			"unmappedWarning": "Otilldelade segment — omappade meter räknas inte",
			"createMeasurement": "Skapa mätning",
			"selectHint": "Markera kabellinjerna som ska ingå och skapa sedan mätningen",
			"continueHint": "Klicka för att fortsätta sträckan · Esc för att avsluta",
			"routing": {
				"title": "Dragning",
				"angle": "Vinkelbegränsning",
				"angle90": "Ortogonal (90°)",
				"angle45": "Tillåt 45°",
				"angleFree": "Fri",
				"gridRotation": "Rutnätsriktning",
				"gridRotationAuto": "Auto",
				"gridRotationInfo": "Rutnätsriktning: {{degrees}}°",
				"mode": "Läge",
				"mode_exact": "Exakt",
				"mode_angled": "Vinklad",
				"mode_smart": "Smart",
				"modeHint_exact": "Nya mätningar följer den ritade sträckan exakt.",
				"modeHint_angled": "Nya mätningar förenklas och fästs mot vinkelrutnätet.",
				"modeHint_smart": "Nya mätningar förenklas som Vinklad; Beräkna sträcka fäster den valda mätningen mot bekräftade väggar och stegar.",
				"variantMap": "Kabel per vägledning",
				"variantMapDesc": "Vilken installationsvariant av mätningens kabel ett ben får när det löper på en stege eller längs en vägg. Kommas ihåg per kabel.",
				"variantMap_tray": "Stege",
				"variantMap_wall": "Vägg",
				"variantNone": "Ingen kabel",
				"variantSingle": "En installationsmetod",
				"guideLayers": "Vägledningslager",
				"guideLayersDesc": "Ritningslager vars väggar och stegar Smart dragning fäster mot på denna sida. Välj: välj vägg eller stege, klicka på en linje per lager på ritningen, bekräfta. Öga- och fokusknapparna ändrar bara vad ritningen visar — dolda lagers vägledningar drar fortfarande.",
				"guideLayersEmpty": "Inga vägledningar på denna sida ännu.",
				"useForRouting": "Använd för dragning",
				"guideHighlights": "Markera vägledningar på ritningen",
				"isolateGuideLayers": "Visa endast vägledningslager",
				"clearGuides": "Rensa",
				"clearGuidesDesc": "Ta bort alla vägledningar på denna sida (ångra med Ctrl+Z).",
				"guidesCleared": "{{count}} vägledningar borttagna",
				"pickKind_wall": "Väggar",
				"pickKind_tray": "Stegar",
				"pick": "Välj…",
				"pickKindDesc": "Vad nästa val lägger till: vägglinjer eller kabelstegar.",
				"pickStatus_wall": "Väljer väggar: {{count}} lager",
				"pickStatus_tray": "Väljer stegar: {{count}} lager",
				"pickHint": "Klicka på en linje per lager på ritningen. Varje lager under klicket listas — bocka i vägg- eller stegelagret, bocka ur text- och skrafferingslager. Bekräfta när du är klar.",
				"pickLayersUnderClick": "Lager under dina klick",
				"pickConfirm": "Lägg till {{count}} lager",
				"snapTolerance": "Sökavstånd",
				"snapToleranceDesc": "Hur långt från linjen i originalritningen Smart dragning söker efter väggar och stegar. En del av sträckan inom detta avstånd från en vägledning (och ungefär parallell med den) flyttas till vägledningen. Visas som ett band runt den valda sträckan.",
				"toleranceBandLabel": "± {{value, number(maximumFractionDigits: 2)}} m",
				"deviationBandLabel": "max {{value, number(maximumFractionDigits: 2)}} m",
				"computing": "Beräknar sträcka…",
				"computeError": "Sträckberäkning misslyckades: {{message}}",
				"retry": "Försök igen",
				"legKinds": "{{onGuide}} av {{total}} ben på vägledningar",
				"detectRunning": "Identifierar…",
				"detectEmpty": "Inga {{kind}}-linjer hittades på {{layers}} — välj en linje på själva vägg- eller stegelagret (inte ett text- eller skrafferingslager).",
				"detectEmptyKind_wall": "vägg",
				"detectEmptyKind_tray": "stege",
				"detectRunningLayers": "Identifierar på {{layers}}…",
				"guideStale": "{{count}} inaktuella — ritningen har ändrats sedan de lades till; rensa och välj igen.",
				"recorder": "Träningsfall",
				"recorderDesc": "Utvecklarverktyg: samla in sträckor för att justera Smart dragning. Dra en post, korrigera dess sträcka tills den är den du vill ha, Lägg till den; Export skriver varje inspelad posts nuvarande sträcka som förväntad sträcka för testverktyget (bun routing:import). Lagras endast i denna webbläsare.",
				"recorderCount": "{{count}} på denna sida",
				"recorderAdd": "Lägg till",
				"recorderAddDesc": "Spela in den valda posten (dess ritade geometri + nuvarande sträcka) som ett träningsfall.",
				"recorderRemove": "Ta bort",
				"recorderRemoveDesc": "Glöm den valda postens träningsfall.",
				"recorderExport": "Exportera",
				"recorderExportDesc": "Ladda ner denna sidas fall som en routing-export-JSON.",
				"recorderClearDesc": "Glöm alla träningsfall på denna sida.",
				"recorderNoDrawn": "Den valda postens ritade geometri är inte tillgänglig på denna sida — den kan inte spelas in.",
				"recorderSkipped": "{{count}} fall hoppades över: deras poster finns inte längre.",
				"guideSelected_wall": "Vald vägledning: vägg",
				"guideSelected_tray": "Vald vägledning: stege",
				"deleteGuide": "Ta bort vägledning",
				"detectUnavailableLayer": "Detta lager har ingen linjedata.",
				"detectUnavailablePage": "Denna ritning har ingen linjedata.",
				"detectError": "Identifiering misslyckades: {{message}}",
				"guidesConfirmed": "{{count}} vägledningar tillagda",
				"execute": "Beräkna sträcka",
				"preview": "Förhandsgranska",
				"executeHintNoEntry": "Välj en sträckmätning för att dra om den.",
				"modeDesc": "Hur nya avståndsmätningar dras, och vad Beräkna sträcka tillämpas på för den valda.",
				"angleDesc": "Tillåtna benriktningar efter förenkling. I Smart-läge formar detta de fria benen mellan vägledningar; ben på en vägledning följer vägledningen.",
				"angle90Desc": "Varje ben horisontellt eller vertikalt på rutnätet (L-formade hörn).",
				"angle45Desc": "Tillåter även 45°-diagonaler (högst en extra böj per ben).",
				"angleFreeDesc": "Ingen fästning — endast tolerans- och kortaste-segment-passen.",
				"gridRotationDesc": "Vilken riktning vinkelrutnätet följer: sträckan själv, arkets axlar eller en linje du väljer på ritningen.",
				"gridRotationAutoDesc": "Rikta rutnätet mot sträckans egen dominerande riktning (byggnadens axlar).",
				"gridRotationSheet": "Arkets axlar",
				"gridRotationSheetDesc": "Rikta rutnätet mot arkets egna x/y-axlar (0°).",
				"gridRotationPick": "Välj från ritning",
				"gridRotationPickDesc": "Klicka på en vägg eller linje på ritningen — rutnätet följer dess riktning. Klicka igen för att avbryta.",
				"gridRotationPicking": "Klicka på en linje på ritningen för att ange rutnätsriktningen (Esc avbryter).",
				"gridRotationPicked": "Rutnätsriktning satt till {{degrees}}° från den valda linjen.",
				"gridRotationPickFailed": "Det objektet har ingen linjeriktning att följa.",
				"toleranceDesc": "Små skakningar rätas ut: den beräknade sträckan får avvika från linjen i originalritningen med som mest så här mycket. Större värde = färre hörn.",
				"minLengthDesc": "Ben som är kortare än detta slås ihop med ett grannben när det håller vinklarna giltiga.",
				"tolerance": "Max avvikelse",
				"minLength": "Kortaste segment",
				"lengthDelta": "Längd: {{before}} m → {{after}} m ({{signedDelta}} m, {{signedPct}} %)",
				"lengthDeltaNoPct": "Längd: {{before}} m → {{after}} m ({{signedDelta}} m)",
				"apply": "Tillämpa",
				"confirm": "Bekräfta",
				"rerouteConfirm": "Denna sträcka redigerades manuellt. Ersätt den?",
				"droppedWarning": "Segmentkablar och Δh-värden återställdes. Tidigare totalt vertikalt avstånd: {{totalDeltaH}} m — ange värden per segment igen.",
				"deviation": "Uppskattad max avvikelse: {{meters}} m",
				"staleNotice": "Sträckan ändrades någon annanstans — kör dragningen igen.",
				"rerun": "Kör igen",
				"noLength": "Sträckan har ingen mätbar längd.",
				"noSource": "Den ritade geometrin bakom denna sträcka är inte tillgänglig på denna sida — öppna sidan den mättes på."
			}
		},
		"grouping": {
			"title": "Markeringsgruppering",
			"granularity": {
				"baked": "Fast",
				"tight": "Tät",
				"medium": "Medel",
				"loose": "Lös"
			},
			"scope": {
				"layer": "Detta lager",
				"nearby": "Närliggande",
				"all": "Alla lager"
			},
			"auto": "Auto",
			"tuning": "Justerar…",
			"streamGap": "Strömlucka",
			"connectGap": "Anslutningslucka",
			"clusterDist": "Klusteravstånd",
			"autoDist": "Autoavstånd",
			"autoDistTitle": "Härled klusteravstånd per klick från det lokala luckhistogrammet"
		},
		"settings": "Inställningar",
		"loadingProgress": {
			"title": "Laddar ritning",
			"steps": {
				"download": "Laddar ner",
				"process": "Bearbetar",
				"render": "Renderar",
				"sync": "Synkroniserar"
			}
		},
		"layerConfig": {
			"title": "Lagerkonfigurationer",
			"button": "Konfigurationer",
			"name": "Namn",
			"namePlaceholder": "Konfigurationsnamn",
			"description": "Beskrivning",
			"descriptionPlaceholder": "Valfria anteckningar",
			"setDefault": "Ange som standard",
			"save": "Spara",
			"apply": "Tillämpa",
			"delete": "Ta bort",
			"default": "Standard",
			"empty": "Inga sparade konfigurationer ännu.",
			"nameTooShort": "Namnet måste vara minst {{min}} tecken.",
			"saved": "Konfiguration sparad",
			"saveFailed": "Det gick inte att spara konfigurationen",
			"deleteFailed": "Det gick inte att ta bort konfigurationen"
		},
		"layerManager": {
			"title": "Lager",
			"titleFiltered": "Lager ({{shown}}/{{total}})",
			"titleAll": "Lager ({{total}})",
			"filterPlaceholder": "Filtrera lager...",
			"close": "Stäng lagerpanel",
			"showHidden": "Visa dolda lager",
			"showLayer": "Visa lager",
			"hideLayer": "Dölj lager",
			"pinLayer": "Fäst lager",
			"unpinLayer": "Lossa lager",
			"lockSelection": "Lås markering",
			"enableSelection": "Aktivera markering",
			"showAll": "Visa alla",
			"hideAll": "Dölj alla",
			"lockAll": "Lås alla",
			"unlockAll": "Lås upp alla",
			"pinAll": "Fäst alla",
			"unpinAll": "Lossa alla",
			"restoreDefaults": "Återställ standard",
			"show": "Visa",
			"hide": "Dölj",
			"lock": "Lås",
			"unlock": "Lås upp",
			"pin": "Fäst",
			"unpin": "Lossa",
			"reset": "Återställ"
		},
		"classification": {
			"title": "Klassificering",
			"scheme": "Nomenklatur",
			"showAll": "Visa alla nomenklaturer",
			"search": "Sök klassificering",
			"back": "Tillbaka",
			"clear": "Rensa klassificering",
			"unclassified": "Oklassificerad",
			"mixed": "Blandad",
			"system": "System",
			"systemHint": "Valfritt. Lägg till en beteckning (t.ex. L.01) för att skilja mellan poster som delar denna klassificering.",
			"nodeOnly": "Endast typ (inget konkret system)",
			"createSystem": "Lägg till ID",
			"systemName": "Systemnamn",
			"systemTunnus": "Beteckning",
			"addSystem": "Lägg till system",
			"usedInTakeoff": "Använd i denna mängdavtagning",
			"position": "Position",
			"positionMixedPlaceholder": "Blandad — lämna oförändrad",
			"save": "Spara",
			"cancel": "Avbryt",
			"selected": "Vald klassificering",
			"stale": "Inaktuell klassificering"
		},
		"preparingSelection": "Förbereder urval…",
		"marker": {
			"capReached": "Urvalsgränsen har nåtts ({{max}} objekt)",
			"belongsToOtherEntry": "Ingår redan i en annan mätning",
			"alreadySelected": "Redan vald – ta bort med suddgummit",
			"nothingToErase": "Inget valt här att ta bort",
			"outsideFocus": "Fokus låst: bara fokuslager kan väljas",
			"outsideFocusRelease": "Lås upp för att välja från andra lager",
			"controls": {
				"toolbar": "Markeringsverktyg",
				"marker": "Märkpenna (M)",
				"eraser": "Suddgummi (E)",
				"undo": "Ångra urval (Ctrl+Z)",
				"redo": "Gör om urval (Ctrl+Shift+Z)",
				"size": "Storlek",
				"sizeValue": "{{value}} px",
				"settings": "Nedtoning",
				"dim": "Tona ned andra lager (D)",
				"dimStrength": "Synlighet för nedtonade lager",
				"focusLock": "Fokuslås (L)",
				"tapScope": "Tryck väljer (G)",
				"tapScopeSmart": "Smart",
				"tapScopeGroup": "Grupper",
				"tapScopeSingle": "Element",
				"sizeTapOnly": "Storleken gäller smart markering"
			}
		},
		"minimap": {
			"label": "Minikarta"
		}
	},
	"errors": {
		"invalidTakeoffLink": "Ogiltig länk till mängdavtagning",
		"invalidTakeoffLinkDescription": "Planeringslänken saknar ett giltigt id för mängdavtagning.",
		"invalidDrawingLink": "Ritning inte tillgänglig",
		"invalidDrawingLinkDescription": "Denna fil är inte en bifogad ritning i mängdavtagningen."
	},
	"packageUpdate": {
		"title_one": "Arbetspaket uppdaterat",
		"title_other": "Arbetspaket uppdaterade",
		"description_one": "{{count}} mätning i denna mängdavtagning använder det. Uppdatera det för att använda det nya innehållet?",
		"description_other": "{{count}} mätningar i denna mängdavtagning använder dem. Uppdatera dem för att använda det nya innehållet?",
		"affected_one": "{{count}} mätning",
		"affected_other": "{{count}} mätningar",
		"keepNote": "Om du hoppar över detta behåller mätningarna det innehåll de skapades med. Du kan uppdatera dem senare.",
		"notNow": "Inte nu",
		"update": "Uppdatera mätningar"
	}
}
